// @ts-nocheck

import React, { useCallback, useMemo } from 'react';

import { ModalContentSpacing, ModalFormat } from '../../constants/ui/modal';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import useOpenBoomView from '../../modules/boom/hooks/useOpenBoomView';
import useOpenGRView from '../../modules/gift-race/hooks/useOpenGRView';
import theme from '../../styled-components/dark';
import { navigateBack } from '../../utils/navigation';
import LoginContainer from '../Login/LoginContainer';
import Modal from '../Modal';

type MobileLoginModalViewProps = {
  className?: string;
};

const MobileLoginModalView = (ownProps: MobileLoginModalViewProps) => {
  const { history, location } = useRouter();
  const openGRView = useOpenGRView();
  const openBoomView = useOpenBoomView();

  const onClose = useCallback(() => {
    navigateBack({ history, location, openGRView, openBoomView });
  }, [history, location, openGRView, openBoomView]);

  const actionsProps = useMemo(
    () => ({
      onClose,
    }),
    [onClose],
  );

  const enhancedProps = useMergeProps({ ownProps, actionsProps });

  return (
    <Modal contentSpacing={ModalContentSpacing.NONE} format={ModalFormat.FULLSCREEN} zIndex={theme.ZIndices.loginModal}>
      <LoginContainer {...enhancedProps} />
    </Modal>
  );
};

export default MobileLoginModalView;
